<template>
  <div id="enroll_lists">
    <h1>
      活动报名管理列表
      <el-button @click="editDialog = true" type="text" size="small"
        >新建</el-button
      >
    </h1>
    <el-table :data="tableShow">
      <el-table-column prop="id" label="活动ID" />
      <el-table-column prop="type" label="活动类型" />
      <el-table-column prop="title" label="活动标题" />
      <el-table-column prop="city" label="举办城市" />
      <!-- <el-table-column prop="startTime" label="开始时间"/> -->
      <!-- <el-table-column prop="expireTime" label="结束时间"/> -->
      <el-table-column label="开始时间" width="105px">
        <template slot-scope="scope">
          {{ scope.row.startTime | format }}
        </template>
      </el-table-column>
      <el-table-column label="结束时间" width="105px">
        <template slot-scope="scope">
          {{ scope.row.expireTime | format }}
        </template>
      </el-table-column>
      <el-table-column label="报名时间" width="105px">
        <template slot-scope="scope">
          {{ scope.row.signupTime | format }}
        </template>
      </el-table-column>
      <el-table-column prop="limit" label="可报名人数" />
      <el-table-column fixed="right" label="开放状态">
        <template slot-scope="scope">
          <div
            :class="[
              'switch-b',
              scope.row.status === 1 ? 'active-switch-b' : ''
            ]"
            @click="updateenroll(scope.row)"
          >
            <div
              :class="[
                'switch-b-div',
                scope.row.status === 1 ? 'active-div' : ''
              ]"
            ></div>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="报名链接">
        <template slot-scope="scope">
          <a :href="'/meetings/enroll/' + scope.row.id" target="_blank"
            >报名链接</a
          >
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="相关操作" min-width="200">
        <template slot-scope="scope">
          <el-button @click="editrow(scope.row)" type="text" size="small"
            >编辑会议</el-button
          >
          <el-button @click="inforow(scope.row.id)" type="text" size="small"
            >通知参会</el-button
          >
          <el-button
            @click="allUser(scope.row.type, scope.row.id)"
            type="text"
            size="small"
            >已申请报名用户</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <editenroll
      :info="editData"
      @closeDialog="closeDialog"
      v-if="editDialog"
    ></editenroll>
  </div>
</template>

<script>
import editenroll from "./edit_enroll.vue";
import moment from "moment";
export default {
  components: { editenroll },
  data() {
    return {
      tableShow: [],
      editDialog: false,
      editData: null
    };
  },
  filters: {
    format(i) {
      return moment(+i).format("YYYY-MM-DD HH:mm");
    }
  },
  methods: {
    allUser(type, id) {
      this.$router.push(`/users/enroll/${id}`);
    },
    inforow(id) {
      this.$router.push(`/sms/enroll/${id}`);
    },
    editrow(data) {
      this.editDialog = true;
      this.editData = data;
    },
    closeDialog(status) {
      this.editDialog = false;
      this.editData = null;
      if (status) {
        this.getenrollLists();
      }
    },
    async getenrollLists() {
      let res = await this.$http.getEnrollAcList();
      if (res.data.statusCode === 200) {
        this.tableShow = res.data.result;
      } else {
        this.$message({
          type: "error",
          message: res.data.message
        });
      }
    },
    async updateenroll(data) {
      console.log(data);
      data.status = data.status === 1 ? 0 : 1;
      console.log(data);
      let res = await this.$http.updateEnroll(data);
      if (res.data.statusCode === 200) {
        this.getenrollLists();
      } else {
        data.status = data.status === 1 ? 0 : 1;
        this.$message({
          type: "error",
          message: res.data.message
        });
      }
    }
  },
  created() {
    this.getenrollLists();
  }
};
</script>

<style scoped>
.switch-b {
  margin-left: 20px;
  width: 40px;
  height: 22px;
  border-radius: 15px;
  background-color: rgb(218, 0, 0) !important;
  transition: background-color 400ms;
  cursor: pointer;
  position: relative;
}
.active-switch-b {
  background-color: rgb(0, 202, 216) !important;
}
.switch-b-div {
  position: absolute;
  top: 50%;
  margin: 0 2px;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background-color: #fff;
  transition: transform 400ms;
  transform: translateX(0%) translateY(-50%);
}
.active-div {
  transform: translateX(100%) translateY(-50%);
}
.over-time {
  color: red;
  margin-left: 5px;
}
.close-time {
  margin-left: 5px;
  color: lightseagreen;
}
</style>



// WEBPACK FOOTER //
// src/components/backend/enroll/enroll_list.vue